import { DashboardMetrics } from "@/components/host/dashboard/DashboardMetrics";
import { QuickActions } from "@/components/host/dashboard/QuickActions";
import { BookingManager } from "@/components/host/bookings/BookingManager";
import { AnalyticsDashboard } from "@/components/host/analytics/AnalyticsDashboard";
import { DocumentUpload } from "@/components/host/verification/DocumentUpload";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

const HostDashboardPage = () => {
  const { data: verificationStatus, isError } = useQuery({
    queryKey: ['host-verification-status'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Not authenticated");

      const { data, error } = await supabase
        .from('host_verification_requirements')
        .select('*')
        .eq('host_id', user.id)
        .maybeSingle();

      if (error && error.code !== 'PGRST116') {
        console.error('Error fetching verification status:', error);
        throw error;
      }

      return data;
    }
  });

  const showDocumentUpload = !verificationStatus?.government_id_submitted;

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-bold mb-6">Dashboard</h1>
      
      <DashboardMetrics />
      <QuickActions />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <BookingManager />
        {showDocumentUpload && (
          <DocumentUpload />
        )}
      </div>

      <AnalyticsDashboard />
    </div>
  );
};

export default HostDashboardPage;